import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import { shallowEqual } from 'react-redux';
import HrbTranslate from '../../../components/language/HrbTranslate';
import Button from '../../../components/library/buttons/Button';
import AccordionRight from '../../../components/library/graphics/AccordionRight';
import AssignedOfficesListBox from './AssignedOfficesListBox';
import AvailableOfficesListBox from './AvailableOfficesListBox';
import '../../../stylesheets/custom_scrollbar.scss';
import './AutoAssignModal.scss';

const AutoAssignModalOfficesTab = (props) => {

    const { onChanged, availableOffices, assignedOffices, homeOffice } = props

    // arrays to hold local values for checked and assigned office ids
    const [checkedOfficeIds, setCheckedOfficeIds] = useState([])

    const handleAssignedOfficeIdsChanged = officeIds => {
        let assignedOfficeIds = assignedOffices.map(o => o.id)

        if (!shallowEqual(officeIds, assignedOfficeIds)) {
            onChanged(officeIds)
        }
    }

    const handleCheckedOfficeIdsChanged = officeIds => {
        if (!shallowEqual(officeIds, checkedOfficeIds)) {
            setCheckedOfficeIds(officeIds)
        }
    }

    const handleAssignButtonClicked = () => {
        let assignedOfficeIds = assignedOffices.map(o => o.id)
        
        // union the existing assigned id list with the checked office lsit
        let newAssignedIds = Array.from(new Set(assignedOfficeIds.concat(checkedOfficeIds)))
        // clear all checked selections
        setCheckedOfficeIds([])
        // notify
        onChanged(newAssignedIds)
    }

    return (
        <Fragment>
            <div className='columns content'>
                <div className='column is-10 is-offset-1'>
                    <p className='p1 has-text-weight-bold my-2'><HrbTranslate text='AssociateOfficesModal.OfficesHeader' /></p>
                    <p className='p2 content mb-3'><HrbTranslate text='AssociateOfficesModal.OfficesDescription' /></p>
                </div>
            </div>
            <div className='columns content'>
                <div className='column is-10 is-offset-1 columns px-0 py-0'>
                    <AvailableOfficesListBox availableOffices={availableOffices} checkedOfficeIds={checkedOfficeIds}
                        onCheckedOfficesChanged={handleCheckedOfficeIdsChanged} />
                    <div className='column is-2 is-flex is-justify-content-center is-align-content-center mt-5'>
                        <Button elementId='office-assign-btn'
                            buttonStyles='icon-button'
                            onClick={handleAssignButtonClicked}
                            disabled={(!checkedOfficeIds || checkedOfficeIds.length === 0)}>
                            <AccordionRight />
                        </Button>
                    </div>
                    <AssignedOfficesListBox homeOffice={homeOffice} assignedOffices={assignedOffices}
                        onAssignedOfficesChanged={handleAssignedOfficeIdsChanged} />
                </div>
            </div>
        </Fragment>
    );
}

AutoAssignModalOfficesTab.whyDidYouRender = false;

AutoAssignModalOfficesTab.propTypes = {
    impersonatingId: PropTypes.number,
    associate: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    onChanged: PropTypes.func.isRequired,
    onUpdated: PropTypes.func,
    onCancel: PropTypes.func
}

export default AutoAssignModalOfficesTab